// extracted by mini-css-extract-plugin
export default {"numStepper":"num_numStepper__Vlt7F","numStepperValue":"num_numStepperValue__MdKrR"};